export default __webpack_public_path__ + "static/media/line.1bdf8890.svg";